export const gradientColorString = (colors: string[]) => {
  const colorCount = colors.length;

  return colors
    .map((color, i) => {
      const start = (i / colorCount) * 100;
      const end = ((i + 1) / colorCount) * 100;
      return `${color} ${start}%, ${color} ${end}%`;
    })
    .join(', ');
};
